const HomePage = () => {
    return <>silence is golden</>
}

export default HomePage;